const endPoints = {
  auth: {
    login: 'auth/login',
    register: 'auth/register',
    logout: 'logout',
    token: 'token',
    reset: 'auth/resetPassword',
    find: 'auth/find',
    createResetRequest: 'auth/createResetRequest',
    resendVerificationEmail: 'auth/email/resendVerificationEmail',
  },
  register: {
    autocompleteConstantes: 'register/constantes/autocomplete',
    terminosYCondiciones: 'register/terminosYCondiciones',
    initForm: 'register/initForm',
    autocompleteTipoIdentificacion: 'register/tipoidentificacion/autocomplete',
    autocompletePais: 'register/pais/autocomplete',
    autocompleteCiudad: 'register/ciudad/autocompleteByDepartamento',
    autocompleteDepartamento: 'register/departamento/autocompleteByPais',
    autocompleteNivelEducativo: 'register/niveleducativo/autocomplete',
  },
  dashboard: {
    totalTramites: 'broker/estadisticas/totaltramites',
    eficaciaTramites: 'broker/estadisticas/eficaciatramites',
    lineasVendidas: 'broker/estadisticas/lineasvendidas',
    radicadoSucursal: 'broker/estadisticas/radicadosucursal',
  },
  seguridad: {
    allPermisos: {
      base: 'seguridad/permisos',
    },
    usuarios: {
      assignRoles: 'seguridad/usuarios/asignarRoles',
      autocomplete: 'seguridad/usuarios/autocomplete',
      base: 'seguridad/usuarios',
      excel: 'seguridad/usuarios/excel',
      basePerfil: 'seguridad/usuarios/perfil',
      usuariosExcel: 'seguridad/usuarios/usuariosExcel',
      cambioEstado: 'seguridad/usuarios/cambioestado',
      create: 'seguridad/usuarios/create',
      delete: 'seguridad/usuarios/permisos/eliminar',
      getImageForUser: 'seguridad/usuarios/getimage',
      initFormComponent: 'seguridad/usuarios/initFormComponent',
      initFormPerfil: 'seguridad/usuarios/perfil/initform',
      informacion: 'seguridad/usuarios/informacion',
      updateinfo: 'seguridad/usuarios/updateinfo',
      permisos: 'seguridad/usuarios/permisos',
      password: 'seguridad/usuarios/perfil/password',
      update: 'seguridad/usuarios/update',
      roles: {
        base: 'seguridad/userroles',
        assignRoles: 'seguridad/userroles/asignarRoles',
        getRolesNotInUser: 'seguridad/userroles/getRolesNotInUser',
      },
    },
    roles: {
      base: 'seguridad/roles',
      excel: 'seguridad/roles/excel',
      permisos: 'seguridad/roles/permisos',
    },
    permisos: {
      byRole: 'seguridad/permisos/byRole',
      byUser: 'seguridad/permisos/byUser',
      autocomplete: 'seguridad/permisos/autocomplete',
    },
  },
  catalogo: {
    maestros: {
      categoriaProductos: {
        base: 'catalogo/categoriasproductos',
        excel: 'catalogo/categoriasproductos/excel',
      },
      productos: {
        base: 'catalogo/productos',
        excel: 'catalogo/productos/excel',
        imagenes: {
          base: 'catalogo/productosimagenes',
        },
      },
    },
    procesos: {
    },
  },
  miPerfil: {
    maestros: {
      servicios: {
        base: 'miperfil/servicios',
      },
      clasificacionUsuarios: {
        base: 'miperfil/clasificacionusuarios',
      },
      identidadSexual: {
        base: 'miperfil/identidadessexuales',
        autocomplete: 'miperfil/identidadessexuales/autocomplete',
      },
      orientacionSexual: {
        base: 'miperfil/orientacionessexuales',
        autocomplete: 'miperfil/orientacionessexuales/autocomplete',
      },
      tipoOral: {
        base: 'miperfil/tiposorales',
      },
      tipoFantasiaFetiche: {
        base: 'miperfil/tiposfantasiasyfetiches',
      },
      tipoMasaje: {
        base: 'miperfil/tiposmasajes',
      },
      serviciosVirtuales: {
        base: 'miperfil/serviciosvirtuales',
      },
      ojos: {
        base: 'miperfil/ojos',
      },
      cabellos: {
        base: 'miperfil/cabellos',
      },
      cuerpos: {
        base: 'miperfil/cuerpos',
      },
      pieles: {
        base: 'miperfil/pieles',
      },
      bustos: {
        base: 'miperfil/bustos',
      },
      colas: {
        base: 'miperfil/colas',
      },
      pollas: {
        base: 'miperfil/pollas',
      },
      idiomas: {
        base: 'miperfil/idiomas',
        autocomplete: 'miperfil/idiomas/autocomplete',
      },
      depilaciones: {
        base: 'miperfil/depilaciones',
      },
      etnias: {
        base: 'miperfil/etnias',
      },
      criptomonedas: {
        base: 'miperfil/criptomonedas',
        excel: 'miperfil/criptomonedas/excel',
        autocomplete: 'miperfil/criptomonedas/autocomplete',
      },
      redes: {
        base: 'miperfil/redes',
        autocomplete: 'miperfil/redes/autocomplete',
      },
    },
    procesos: {
    },
  },
  general: {
    maestros: {
      constantes: {
        autocomplete: 'general/constantes/autocomplete',
      },
      images: {
        base: 'general/images',
      },
      terminosYCondiciones: {
        base: 'general/terminosYCondiciones',
        excel: 'general/terminosYCondiciones/excel',
        initFormComponent: 'general/terminosYCondiciones/initFormComponent',
        getRe: 'general/terminosYCondiciones/viewFile',
      },
      metodosPago: {
        base: 'general/metodosdepago',
        excel: 'general/metodosdepago/excel',
      },
      perfil: {
        base: 'general/perfil',
        cambioEstado: 'general/perfil/cambioestado',
        ubicaciones: {
          base: 'general/perfilubicaciones',
        },
        servicios: {
          base: 'general/perfilservicios',
        },
        descripcionesFisicas: {
          base: 'general/perfildescripcionesfisicas',
        },
      },
      perfilMedia: {
        base: 'general/perfilmedia',
        report: 'general/perfilmedia/report',
        controlBase: 'general/perfilmedia/control',
      },
      usuarioImagenes: {
        base: 'general/usuarioimagenes',
        controlBase: 'general/usuarioimagenes/control',
        report: 'general/usuarioimagenes/report',
        download: 'general/usuarioimagenes/download',
      },
      bancos: {
        base: 'general/bancos',
        excel: 'general/bancos/excel',
        autocomplete: 'general/bancos/autocomplete',
      },
      informacionPago: {
        base: 'general/informacionpago',
        initFormComponent: 'general/informacionpago/initformcomponent',
      },
      beneficiario: {
        base: 'general/beneficiarios',
        initFormComponent: 'general/beneficiarios/initformcomponent',
      },
      tiposUsuario: {
        base: 'general/tiposusuarios',
        excel: 'general/tiposusuarios/excel',
      },
      parentesco: {
        base: 'general/parentescos',
        excel: 'general/parentescos/excel',
      },
      paises: {
        base: 'divisionPolitica/paises',
        excel: 'divisionPolitica/paises/excel',
        autocomplete: 'divisionPolitica/paises/autocomplete',
      },
      departamentos: {
        base: 'divisionPolitica/departamentos',
        excel: 'divisionPolitica/departamentos/excel',
        autocomplete: 'divisionPolitica/departamentos/autocomplete',
      },
      ciudades: {
        base: 'divisionPolitica/ciudades',
        excel: 'divisionPolitica/ciudades/excel',
        autocomplete: 'divisionPolitica/ciudades/autocomplete',
      },
      monedas: {
        base: 'general/monedas',
        excel: 'general/monedas/excel',
      },
    },
    procesos: {
      publicaciones: {
        base: 'general/publicaciones',
        aprobar: 'general/publicaciones/aprobar',
        report: 'general/publicaciones/report',
      },
      consultas: {
        historicoestados: {
          validacionIdentidad: 'historicoestados/consultas/validacionIdentidad',
          perfil: 'historicoestados/consultas/perfilStateMachineHistory',
          suscripciones: 'historicoestados/consultas/suscripcionesStateMachineHistory',
          bonos: 'historicoestados/consultas/bonosStateMachineHistory',
          consultaHistoricoEstados: 'historicoestados/consultas/consultaHistoricoEstados',
          compras: 'historicoestados/consultas/purchasesStateMachineHistory'
        },
      },
    },
  },
  misCompras: {
    maestros: {
      tiposSuscripcion: {
        base: 'miscompras/tipossuscripciones',
      },
      suscripcion: {
        base: 'miscompras/suscripciones',
        getAllSuscripciones: 'miscompras/suscripciones/getAllSuscripciones',
        report: 'miscompras/suscripciones/report',
        cambioEstado: 'miscompras/suscripciones/cambioestado',
        init: 'miscompras/suscripciones/initformcomponent',
      },
    },
    procesos: {
      cart: {
        base: 'miscompras/cart'
      },
      purchase: {
        base: 'miscompras/purchases',
        excel: 'miscompras/purchases/excel',
        comprasexcel: 'miscompras/purchases/comprasexcel',
        cambioEstado: 'miscompras/purchases/cambioestado',
        attachment: {
          base: 'miscompras/purchaseattachment',
        },
        product: {
          base: 'miscompras/purchasesproducts',
          excel: 'miscompras/purchasesproducts/excel',
          administracion: {
            base: 'miscompras/purchasesproducts/administracion',
            excel: 'miscompras/purchasesproducts/administracion/excel',
          },
        },
      },
    },
  },
  misBonos: {
    referidos: 'general/referidos/getReferidosByLevel',
    arbol: 'general/referidos/getArbolReferidos',
    getCicloBonificacionUser: 'bonos/ciclobonificacionuser',
    getAllCiclos: 'bonos/ciclobonificacionuser/getAllCiclos',
    liquidacionBonosExcel: 'bonos/ciclobonificacionuser/liquidacionBonosExcel',
    cambioEstado: 'bonos/ciclobonificacionuser/cambioestado',
    indexByUser: 'bonos/ciclobonificacionuser/indexByUser',
    getCicloBonificacionReferidosUser: 'bonos/ciclobonificacionuserreferido',
  },
  centroAyuda: {
    maestros: {
      ayudasGraficas: {
        base: 'centrodeayuda/ayudasgraficas',
        excel: 'centrodeayuda/ayudasgraficas/excel',
        autocomplete: 'centrodeayuda/ayudasgraficas/autocomplete',
      },
    },
    procesos: {
      sugerencias: {
        base: 'centrodeayuda/sugerencias',
      },
      agendarDemostracion: {
        base: 'centrodeayuda/agendardemostraciones',
      },
      enviarPreguntas: {
        base: 'centrodeayuda/enviarpreguntas',
        cambioEstado: 'centrodeayuda/enviarpreguntas/cambioestado',
      },
      preguntasFrecuentes: {
        base: 'centrodeayuda/preguntasfrecuentes',
        excel: 'centrodeayuda/preguntasfrecuentes/excel',
        ayudasGraficas: {
          base: 'centrodeayuda/preguntasfrecuentesayudasgraficas',
        },
      },
    },
  },
};

export default endPoints;
